import React, {useState} from "react";
import {TextField} from "@mui/material";
import {TextFieldProps} from "@mui/material/TextField/TextField";

/**
 * A simple text field who will submit the entered value when the enter / return key is pressed
 */
export function TextFieldWithEnterHandling(props: {
  onSubmit: (value: string) => void,
} & Partial<Omit<TextFieldProps, 'onSubmit' |  'onChange' | 'value' | 'name'>>) {
  const {onSubmit, ...rest} = props;
  const [value, setValue] = useState('');

  return (
    <TextField
      value={value}
      onChange={event => setValue(event.target.value)}
      onKeyPress={(event) => {
        if (event.code === 'Enter') {
          props.onSubmit(value);
          setValue('');
          event.preventDefault();
        }
      }}
      {...rest}
    />
  )
}
